export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-heading text-lg font-bold">
                51
              </span>
              <span className="font-heading text-xl text-foreground-50 font-bold">51影院</span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              51影院整合奇优影院、98影院、优优色影院、cc影院、96影院等多个热门站点资源，专注提供免费高清影视在线观看服务，每日更新最新片源，满足广大影迷的多样化观影需求。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-100 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              {[
                { label: '热门排行', href: '#ranking' },
                { label: '更新快讯', href: '#updates' },
                { label: '热门话题', href: '#topics' },
                { label: '专题合集', href: '#index' },
                { label: '精选推荐', href: '#cards' },
              ].map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  className="text-sm text-foreground-500 hover:text-primary-400 transition-colors whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-100 mb-4">资源站点</h4>
            <div className="flex flex-col gap-2">
              {['奇优影院', '98影院', '优优色影院', 'cc影院', '96影院'].map((name) => (
                <span key={name} className="text-sm text-foreground-500">
                  {name}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              合作伙伴信息持续更新中，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-700">
            &copy; 2026 51影院 - 影视资源免费高清在线看
          </p>
          <p className="text-xs text-foreground-700">
            本站内容来源于网络，仅供学习交流使用
          </p>
        </div>
      </div>
    </footer>
  );
}